import { render, staticRenderFns } from "./AppointmentRequestViewModal.vue?vue&type=template&id=496b8396&scoped=true&"
import script from "./AppointmentRequestViewModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentRequestViewModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentRequestViewModal.vue?vue&type=style&index=0&id=496b8396&prod&scoped=true&lang=scss&"
import style1 from "./AppointmentRequestViewModal.vue?vue&type=style&index=1&id=496b8396&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b8396",
  null
  
)

export default component.exports